import { InfoCircleOutlined } from "@ant-design/icons";
import styled from "styled-components";

import colors from "../../../../../../themes/colors";

/**
 * A missing position has to be readable as missing at a glance. Rendering it
 * with the same weight as a real amount is how a "no data" row gets mistaken
 * for a zero.
 */
export const PositionsTable = styled.div`
  .income-tax-preview-row-missing {
    background-color: ${colors.veryLightGrey};
    font-style: italic;
  }

  /* The section headings carry the block, so the rows under them do not repeat
   * it. Without the separation the trade tax rows read as inputs to the income
   * tax rows below them. */
  .income-tax-preview-row-group > td {
    background-color: ${colors.veryLightGrey};
    font-weight: 600;
  }
`;

export const GroupHeading = styled.span`
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.5px;
`;

/**
 * Deliberately quiet. The note it opens explains a figure; it does not warn
 * about one, and an icon loud enough to be a warning would undo the reason the
 * notes were taken out of the page in the first place.
 */
export const NoteIcon = styled(InfoCircleOutlined)`
  color: ${colors.darkGrey};
`;

/**
 * A real button, because the note has to be reachable without a mouse.
 *
 * The icon alone is a `<span role="img">`: not focusable, so moving the notes
 * behind it would have put them out of reach of a keyboard entirely, rather
 * than one hover away. Styled down to look like the bare icon it replaces.
 */
export const NoteButton = styled.button`
  border: none;
  background: none;
  padding: 0;
  margin-left: 6px;
  cursor: help;
  line-height: 1;
`;

/**
 * Available to a screen reader, absent from the layout. The text is what the
 * tooltip shows; a reader who cannot open the tooltip still gets it.
 */
export const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
